import React, { useCallback, useState } from 'react';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import LatestItem from './latest-item';
SwiperCore.use([Autoplay]);
/**
 * Swiper機能の初期化
 */
const initSwiper = (latestItemList, onSwiper, onSwiperTouchEnd) => {
    if (latestItemList.length === 0) {
        return null;
    }
    const itemList = [...latestItemList, ...latestItemList, ...latestItemList];
    return (React.createElement("div", { className: "latest-item-group" },
        React.createElement("div", { className: "latest-item-slider" },
            React.createElement(Swiper, { onSwiper: onSwiper, onTouchEnd: onSwiperTouchEnd, freeMode: true, slidesPerView: 'auto', loop: true, loopedSlides: itemList.length * 3, speed: 3000, autoplay: {
                    delay: 0,
                    //disableOnInteraction: false
                } }, createSwiperSlideList(itemList)))));
};
/**
 * スライドアイテムの初期化
 * @param latestItemList
 * @returns
 */
const createSwiperSlideList = (latestItemList) => {
    return latestItemList.map((latestItem, index) => {
        return (React.createElement(SwiperSlide, { key: index },
            React.createElement(LatestItem, { latestItem: latestItem })));
    });
};
const LatestInfo = ({ latestItemList }) => {
    let timerId = 0;
    const [swiper, setSwiper] = useState();
    const onSwiper = useCallback((swiper) => {
        setSwiper(swiper);
        // スライド時のイージング処理を上書きする
        const swiperWrapper = swiper.$wrapperEl[0];
        swiperWrapper.style.transitionTimingFunction = 'linear';
    }, []);
    //
    // スワイプ終了から1秒まって自動スライドを開始する
    const onSwiperTouchEnd = useCallback(() => {
        clearTimeout(timerId);
        timerId = window.setTimeout(() => {
            if (swiper) {
                swiper.autoplay.start();
            }
        }, 3000);
    }, [
        swiper
    ]);
    return (React.createElement("div", null, initSwiper(latestItemList, onSwiper, onSwiperTouchEnd)));
};
export default LatestInfo;
